import { render } from "./event_archive_embedded_video_menu.vue?vue&type=template&id=1801eae3"
import script from "./event_archive_embedded_video_menu.vue?vue&type=script&lang=js"
export * from "./event_archive_embedded_video_menu.vue?vue&type=script&lang=js"

import "./event_archive_embedded_video_menu.vue?vue&type=style&index=0&id=1801eae3&lang=scss"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__